import { en } from './en';

export const de: Record<string, string> = {
  'delivery.title': "Wohin sollen wir Ihre Bestellung liefern?",
  'delivery.beforeSignup': "Prüfen Sie die Liefermöglichkeit, bevor Sie Ihre persönlichen Daten eingeben.",
  'delivery.country': "Lieferland",
  'delivery.choose': "Wählen Sie Ihr Lieferland",
  'delivery.availableTo': "Lieferung nach:",
  'delivery.blocked': "Einige Artikel können nicht in das gewählte Land geliefert werden. Ihr Warenkorb bleibt erhalten. Wählen Sie ein anderes Lieferland oder entfernen Sie die nicht verfügbaren Artikel.",
  'delivery.backToCart': "Zurück zum Warenkorb",
  'delivery.updateAddress': "Lieferadresse ändern",
  'delivery.checkFailed': "Die Liefermöglichkeit konnte nicht geprüft werden. Ihr Warenkorb bleibt erhalten. Bitte versuchen Sie es erneut.",
  'delivery.retry': "Erneut versuchen",
  'delivery.checking': "Liefermöglichkeit wird geprüft…",
  ...en,
  'cart.adding': 'Wird hinzugefügt...',
  'cart.added': 'Hinzugefügt',
  'cart.addSuccess': 'Produkt zum Warenkorb hinzugefügt',
  'cart.addFail': 'Produkt konnte nicht hinzugefügt werden: {error}',
  'title.cart': 'Warenkorb',
  'title.catalog': 'Katalog',
  'title.checkout': 'Kasse',
  'title.signup': 'Registrieren',
  'title.tickets': 'Support-Tickets',
  'title.discounts': 'Ihr persönlicher Rabatt',
  'auth.login': 'Anmelden',
  'auth.loginModal.remindPassword': 'Passwort vergessen?',
  'auth.logout': 'Abmelden',
  'auth.signup': 'Registrieren',
  'auth.myAccount': 'Mein Konto',
  'auth.orders': 'Meine Bestellungen',
  'auth.discount': 'Ihr persönlicher Rabatt!',
  'discounts.title': 'Ihr persönlicher Rabatt',
  'discounts.description': 'Dieser Rabatt wird automatisch auf alle Ihre Bestellungen angewendet.',
  'auth.bonusAccount': 'Ihr Bonus-Konto',
  'auth.referral': 'Empfehlungsprogramm',
  'auth.subscriptions': 'Abonnements',
  'title.subscriptions': 'Abonnements',
  'subs.loading': 'Wird geladen...',
  'subs.loginRequired': 'Bitte melden Sie sich an, um Abonnements zu verwalten.',
  'subs.empty': 'Keine Newsletter verfügbar.',
  'subs.instruction': 'Wählen Sie die Newsletter aus, die Sie abonnieren oder abbestellen möchten',
  'subs.list.1.name': 'Produktrabatte',
  'subs.list.1.descr': 'Rabatte auf Produkte, die Sie interessieren. Häufigkeit – monatlich',
  'subs.list.2.name': 'Geburtstagsrabatte',
  'subs.list.2.descr': 'Geburtstags-E-Mail mit Geschenk. Häufigkeit – jährlich',
  'subs.list.3.name': 'Nachfüll-Erinnerung',
  'subs.list.3.descr': 'Erinnerung an Nachbestellung. Häufigkeit – alle 2–3 Monate',
  'subs.list.4.name': 'Shop-Neuigkeiten',
  'subs.list.4.descr': 'Häufigkeit – selten',
  'subs.success': 'Abonnements aktualisiert',
  'subs.failed': 'Aktualisierung fehlgeschlagen.',
  'subs.updating': 'Wird aktualisiert...',
  'subs.update': 'Aktualisieren',
  'inline.loginLink': 'anmelden',
  'inline.loginRequiredPrefix': 'Bitte ',
  'inline.loginRequiredSuffix': ', um diese Seite anzusehen.',
  'inline.subscriptionsAuthRedirect':
    'Newsletter-Abonnements sind nur für angemeldete Kunden verfügbar. Bitte melden Sie sich an, um fortzufahren.',
  'subscribe.title': 'Für Angebote anmelden',
  'subscribe.subtitle': 'Erhalten Sie exklusive Rabatte und Bestellerinnerungen',
  'subscribe.cta': 'Abonnieren',
  'subscribe.emailLabel': 'E-Mail',
  'subscribe.emailPlaceholder': 'ihre@email.de',
  'subscribe.phoneLabel': 'Telefon',
  'subscribe.phonePlaceholder': '+49 123 456789',
  'subscribe.consentLabel': 'Ich stimme dem Erhalt von Werbe-E-Mails und Bestellerinnerungen zu',
  'subscribe.consentRequired': 'Bitte stimmen Sie dem Erhalt von E-Mails zu',
  'subscribe.invalidEmail': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  'subscribe.success': 'Danke! Sie sind angemeldet.',
  'auth.tickets': 'Support-Tickets',
  'auth.deleteAccount': 'Konto löschen',
  'cartWidget.cart': 'Warenkorb',
  'cartWidget.viewCart': 'ZUM WARENKORB',
  'cartWidget.shoppingCart': 'Warenkorb',
  'cartWidget.items': 'Artikel',
  'title.checkoutQnr': 'Medizinischer Fragebogen',
  'title.checkoutConfirm': 'Bestellbestätigung',
  'cartPage.empty': 'Ihr Warenkorb ist leer',
  'cartPage.product': 'Produkt',
  'cartPage.qty': 'Menge',
  'cartPage.price': 'Preis',
  'cartPage.lineTotal': 'Gesamt',
  'cartPage.loading': 'Warenkorb wird geladen...',
  'cartPage.startShopping': 'Einkaufen starten',
  'cartPage.recalculate': 'Neu berechnen',
  'cartPage.remove': 'Entfernen',
  'cartPage.free': 'Kostenlos',
  'cartPage.quickNotes': 'Kurze Hinweise:',
  'cartPage.note1': '1. Versandversicherung garantiert Rückerstattung oder erneuten Versand.',
  'cartPage.note2': '2. Bitcoin-Zahlung gibt 10% Rabatt.',
  'cartPage.note3': '3. Geben Sie unten einen gültigen Rabattcoupon ein.',
  'cartPage.note4': '4. Einige Rabatte werden nach Auswahl der Zahlungsmethode aktiviert.',
  'cartPage.couponPlaceholder': 'Coupon hier eingeben',
  'cartPage.couponLabel': 'Coupon-Code',
  'cartPage.couponSubmit': 'Anwenden',
  'cartPage.couponInvalid': 'Der Coupon ist ungültig oder abgelaufen.',
  'cartPage.couponSuccess': 'Der Coupon wurde erfolgreich hinzugefügt.',
  'cartPage.couponNotApplied': 'Der Coupon wurde nicht angewendet. Er ist ungültig, für die gewählte Zahlungsmethode eingeschränkt oder erfüllt die Aktionsbedingungen nicht.',
  'cartPage.couponCleared': 'Coupon wurde entfernt.',
  'cartPage.itemRemoved': 'Artikel wurde aus dem Warenkorb entfernt.',
  'cartPage.removeFailed': 'Artikel konnte nicht entfernt werden.',
  'cartPage.updateQtyFailed': 'Menge konnte nicht aktualisiert werden.',
  'cartPage.qtyDecrease': 'Menge verringern',
  'cartPage.qtyIncrease': 'Menge erhöhen',
  'cartPage.maxPillsHint': 'Max. {pills} Tabletten ({packs} Packungen)',
  'cartPage.deliveryMethod': 'Liefermethode:',
  'cartPage.standard': 'Standard',
  'cartPage.subtotal': 'Zwischensumme:',
  'cartPage.personalDiscount': 'Persönlicher Rabatt:',
  'cartPage.bonusDiscount': 'Bonusrabatt:',
  'cartPage.discountCoupon': 'Rabattcoupon:',
  'cartPage.clearCoupon': 'Coupon entfernen',
  'cartPage.shippingCost': 'Versandkosten:',
  'cartPage.discounted': 'rabattiert',
  'cartPage.freeShipping': 'kostenloser Versand',
  'cartPage.shippingInsurance': 'Versandversicherung:',
  'cartPage.backToShopping': 'Zurück zum Einkaufen',
  'shippingMethod.airmail_service': 'Luftpost-Service',
  'cartPage.total': 'Gesamt:',
  'cartPage.checkout': 'Zur Kasse',
  'stepper.cart': 'Warenkorb',
  'stepper.payment': 'Zahlung',
  'stepper.medical': 'Medizinisch',
  'stepper.confirm': 'Bestätigen',
  'miniCart.subtotal': 'Zwischensumme:',
  'miniCart.personalDiscount': 'Persönlicher Rabatt:',
  'miniCart.bonusDiscount': 'Bonusrabatt:',
  'miniCart.discountCoupon': 'Rabattcoupon:',
  'miniCart.shippingCost': 'Versandkosten:',
  'miniCart.freeShipping': 'kostenloser Versand',
  'miniCart.shippingInsurance': 'Versandversicherung:',
  'miniCart.total': 'Gesamt:',
  'miniCart.editCart': 'Warenkorb bearbeiten',
  'checkout.continue': 'Weiter',
  'confirm.title': 'Bestellbestätigung',
  'confirm.placeOrder': 'Bestellung aufgeben',
  'qnr.title': 'Medizinischer Fragebogen',
  'confirm.retentionConsent': 'Ich stimme dem Erhalt von Werbe-E-Mails und Bestell-Erinnerungen zu',
  'profile.updateProfile': 'Profil aktualisieren',
  'telegram.title': 'Telegram-Benachrichtigungen',
  'telegram.hint': 'Verbinden Sie Telegram, um Bestellupdates, Sendungsverfolgung und Support-Chat auf Ihrem Telefon zu erhalten.',
  'telegram.orderFcTitle': 'Bestellung per Telegram bestätigen',
  'telegram.orderFcIntro': 'Diese Bestellung erfordert eine kurze Bestätigung Ihrer Daten, bevor wir Zahlungsanweisungen senden können.',
  'telegram.orderFcFastest': 'Schnellste Option: Verbinden Sie unten Telegram. Nach der Bestellung sendet der Bot eine Bestätigungsanfrage.',
  'telegram.orderFcAlternatively': 'Alternativ: telefonisch bestätigen oder',
  'telegram.liveChat': 'Live-Chat',
  'telegram.orderFcReady': 'Wir können die Bestätigungsanfrage an Ihr Telegram senden. Prüfen Sie den Bot-Chat.',
  'telegram.orderInfoTitle': 'Updates in Telegram erhalten',
  'telegram.orderInfoIntro': 'Verbinden Sie unseren Support-Bot für:',
  'telegram.orderInfoItem1': 'Bestellstatus und Versandupdates',
  'telegram.orderInfoItem2': 'Tracking-Scans und Lieferhinweise',
  'telegram.orderInfoItem3': 'Zahlungserinnerungen bei Bedarf',
  'telegram.orderInfoItem4': 'Direkter Support-Chat auf Ihrem Telefon',
  'telegram.statusLoading': 'Telegram-Verbindung wird geprüft…',
  'telegram.unavailable': 'Telegram-Verbindung ist derzeit nicht verfügbar.',
  'telegram.connected': 'Telegram verbunden',
  'telegram.connectedAt': 'Verbunden',
  'telegram.boundFrom': 'Verbunden von',
  'telegram.connect': 'Telegram verbinden',
  'telegram.connecting': 'Verbindung wird hergestellt…',
  'telegram.linkReady': 'Öffnen Sie Telegram und tippen Sie auf Start, um Ihr Konto zu verknüpfen.',
  'telegram.openTelegram': 'Telegram öffnen',
  'telegram.copyLink': 'Link kopieren',
  'telegram.copied': 'Kopiert',
  'telegram.expiresMinutes': 'Der Link läuft in etwa {minutes} Minuten ab.',
  'telegram.notificationsTitle': 'Benachrichtigungseinstellungen',
  'telegram.notificationsHint': 'Bestellbestätigung und Support-Chat funktionieren immer. Wählen Sie unten optionale Hinweise.',
  'telegram.notificationsSaving': 'Speichern…',
  'telegram.notificationsSaveError': 'Benachrichtigungseinstellungen konnten nicht gespeichert werden.',
  'telegram.disconnect': 'Telegram trennen',
  'telegram.disconnectConfirm': 'Telegram von Ihrem Konto trennen? Sie können es jederzeit wieder auf dieser Seite verbinden.',
  'telegram.disconnectYes': 'Ja, trennen',
  'telegram.disconnectCancel': 'Abbrechen',
  'telegram.coupon.checkoutTitle': 'Telegram verbinden und 20 % sparen',
  'telegram.coupon.checkoutBody': 'Jetzt verbinden und wir ziehen 20 % von dieser Bestellung ab.',
  'telegram.coupon.checkoutAction': 'Telegram verbinden & 20 % anwenden',
  'telegram.coupon.applied': 'Telegram verbunden — Ihr Rabatt von 20 % wurde angewendet.',
  'telegram.coupon.replaceConfirm': 'Aktuellen Gutschein ersetzen & 20 % anwenden',
  'telegram.coupon.active': '{percent} % Telegram-Gutschein verfügbar.',
  'telegram.coupon.redeemed': 'Telegram-Gutschein wurde verwendet.',
  'telegram.coupon.expired': 'Telegram-Gutschein ist abgelaufen.',
  'telegram.disconnectError': 'Telegram konnte nicht getrennt werden.',
  'telegram.pref.order_status.label': 'Updates zum Bestellstatus',
  'telegram.pref.order_status.description': 'Bearbeitung, Stornierung, Ablehnung und andere Statusänderungen.',
  'telegram.pref.shipped.label': 'Versand- und Trackingnummern',
  'telegram.pref.shipped.description': 'Wenn Ihre Bestellung versendet oder mit einer Trackingnummer erneut versendet wird.',
  'telegram.pref.tracking_updates.label': 'Tracking-Scans der Lieferung',
  'telegram.pref.tracking_updates.description': 'Updates des Zustellers wie unterwegs, in Zustellung oder zugestellt.',
  'telegram.pref.payment.label': 'Zahlungserinnerungen',
  'telegram.pref.payment.description': 'Zahlungsanweisungen und Hinweise zu Unterzahlungen.',
  'telegram.pref.promotions.label': 'Aktionen und Angebote',
  'telegram.pref.promotions.description': 'Optionale Rabatte und Sonderangebote.',
  'signup.createAccount': 'Konto erstellen',
  'login.title': 'Anmelden',
  'login.loginLabel': 'Login',
  'login.loginPlaceholder': 'E-Mail oder Benutzername',
  'login.passwordLabel': 'Passwort',
  'login.loginRequired': 'Login ist erforderlich',
  'login.passwordRequired': 'Passwort ist erforderlich',
  'login.invalidCredentials': 'Ungultige E-Mail oder ungultiges Passwort.',
  'login.noAccount': 'Noch kein Konto?',
  'login.signupLink': 'Registrieren',
  'login.submit': 'Anmelden',
  'signup.personalInfo': 'Personenbezogene Daten',
  'signup.title': 'Anrede',
  'signup.mr': 'Herr',
  'signup.mrs': 'Frau',
  'signup.ms': 'Frau',
  'signup.firstName': 'Vorname',
  'signup.lastName': 'Nachname',
  'signup.contactInfo': 'Kontaktdaten',
  'signup.email': 'E-Mail',
  'signup.phone': 'Telefon',
  'signup.billingAddress': 'Rechnungsadresse',
  'signup.address': 'Adresse',
  'signup.zipcode': 'Postleitzahl',
  'signup.city': 'Stadt',
  'signup.country': 'Land',
  'signup.state': 'Bundesland',
  'signup.selectCountry': 'Land auswahlen',
  'signup.stateProvince': 'Bundesland / Region',
  'signup.selectState': 'Bundesland auswahlen',
  'signup.shippingAddress': 'Lieferadresse',
  'signup.sameAsBilling': 'Gleich wie Rechnungsadresse',
  'signup.privacyInfo': 'Datenschutz',
  'signup.password': 'Passwort',
  'signup.passwordHint': 'Mindestens 5 Zeichen. Muss sich vom Benutzernamen unterscheiden.',
  'signup.confirmPassword': 'Passwort bestatigen',
  'signup.agreeTermsTemplate': 'Ich stimme den {terms} des Unternehmens zu.',
  'signup.agreeTermsLink': 'Allgemeinen Geschaftsbedingungen',
  'signup.firstNameRequired': 'Vorname ist erforderlich',
  'signup.lastNameRequired': 'Nachname ist erforderlich',
  'signup.emailRequired': 'E-Mail ist erforderlich',
  'signup.emailInvalid': 'Ungultiges E-Mail-Format',
  'signup.phoneRequired': 'Telefon ist erforderlich',
  'signup.addressRequired': 'Adresse ist erforderlich',
  'signup.zipcodeRequired': 'Postleitzahl ist erforderlich',
  'signup.cityRequired': 'Stadt ist erforderlich',
  'signup.countryRequired': 'Land ist erforderlich',
  'signup.passwordRequired': 'Passwort ist erforderlich',
  'signup.passwordMinLength': 'Passwort muss mindestens 5 Zeichen haben',
  'signup.passwordMismatch': 'Passworter stimmen nicht uberein',
  'signup.termsRequired': 'Sie mussen den Bedingungen zustimmen',
  'signup.failed': 'Registrierung fehlgeschlagen',
  'signup.creating': 'Konto wird erstellt...',
  'forgotPassword.emailLabel': 'E-Mail',
  'forgotPassword.emailPlaceholder': 'sie@beispiel.de',
  'forgotPassword.submit': 'Code senden',
  'forgotPassword.success': 'Wir haben einen 10-stelligen Code an Ihre E-Mail gesendet.',
  'forgotPassword.successHint': 'Geben Sie den Code auf der nachsten Seite ein, um ein neues Passwort zu setzen.',
  'forgotPassword.goToSetPassword': 'Code eingeben und Passwort setzen',
  'forgotPassword.backToLogin': 'Zuruck zum Login',
  'forgotPassword.invalidEmail': 'Bitte gultige E-Mail-Adresse eingeben',
  'resetPassword.emailLabel': 'E-Mail',
  'resetPassword.resetCodeLabel': 'Code aus der E-Mail',
  'resetPassword.resetCodePlaceholder': '10 Zeichen',
  'resetPassword.resetCodeFormat': 'Code muss genau 10 Buchstaben oder Zahlen enthalten',
  'resetPassword.newPasswordLabel': 'Neues Passwort',
  'resetPassword.confirmLabel': 'Passwort bestatigen',
  'resetPassword.passwordPlaceholder': '••••••••',
  'resetPassword.passwordMin': 'Passwort muss mindestens 5 Zeichen haben',
  'resetPassword.passwordMismatch': 'Passworter stimmen nicht uberein',
  'resetPassword.submit': 'Speichern',
  'resetPassword.success': 'Passwort aktualisiert. Sie konnen sich jetzt anmelden.',
  'resetPassword.redirectHint': 'Weiterleitung...',
  'orders.title': 'Meine Bestellungen',
  'tickets.newMessage': 'Nachricht',
  'tickets.newUpload': 'Dateien hochladen (PDF, JPG, PNG, TXT)',
  'contact.formTitle': 'Senden Sie uns eine Nachricht',
  'contact.loginRequired': 'Bitte melden Sie sich an, um ein Support-Ticket zu erstellen.',
  'testimonials.customer': 'Kunde',
  'testimonials.loading': 'Kundenstimmen werden geladen...',
  'testimonials.empty': 'Noch keine Kundenstimmen.',
  'testimonials.loadError': 'Kundenstimmen konnten nicht geladen werden. Bitte versuchen Sie es später erneut.',
  'testimonials.formTitle': 'Kundenstimme hinterlassen',
  'testimonials.namePlaceholder': 'Ihr Name',
  'testimonials.messagePlaceholder': 'Ihre Bewertung',
  'testimonials.submitting': 'Wird gesendet...',
  'testimonials.submit': 'Bewertung senden',
  'testimonials.submitError': 'Kundenstimme konnte nicht gesendet werden.',
  'testimonials.loginRequired': 'Bitte melden Sie sich an, um eine Kundenstimme zu hinterlassen.',
  'testimonials.validationName': 'Der Name muss mindestens 2 Zeichen lang sein.',
  'testimonials.validationMessage': 'Die Bewertung muss mindestens 6 Zeichen lang sein.',
  'testimonials.success': 'Vielen Dank fur Ihre Bewertung! Sie erscheint nach der Moderation.',
  'contact.requestFrom': 'Anfrage wird gesendet von',
  'contact.unknownUser': 'Authentifizierter Benutzer',
  'contact.subject': 'Betreff',
  'contact.subjectPlaceholder': 'Wie konnen wir helfen?',
  'contact.message': 'Nachricht',
  'contact.messagePlaceholder': 'Beschreiben Sie Ihr Problem...',
  'contact.send': 'Nachricht senden',
  'contact.ticketsLoginRequired': 'Melden Sie sich an, um Support-Tickets anzusehen und zu erstellen.',
  'chat.online': 'Online',
  'chat.offline': 'Offline',
  'chat.coming_soon': 'Der Live-Chat wird eingerichtet. Bitte nutzen Sie vorerst E-Mail oder Telefon.',
  'chat.offline_message': 'Unsere Mitarbeiter sind derzeit offline.',
  'chat.leave_message': 'Bitte hinterlassen Sie eine Nachricht, wir melden uns bei Ihnen.',
  'chat.leave_ticket': 'Ticket hinterlassen',
  'nav.login': 'Anmelden',
  'nav.signup': 'Konto erstellen',
  'miniCart.deliveryMethod': 'Liefermethode',
  'month.1': 'Januar', 'month.2': 'Februar', 'month.3': 'Marz',
  'month.4': 'April', 'month.5': 'Mai', 'month.6': 'Juni',
  'month.7': 'Juli', 'month.8': 'August', 'month.9': 'September',
  'month.10': 'Oktober', 'month.11': 'November', 'month.12': 'Dezember',
  'checkout.accountHint': 'Kontonummer - steht normalerweise vor der Schecknummer; Der Standort variiert.',
  'checkout.accountNumber': 'Kontonummer',
  'checkout.authLogin': 'Anmelden',
  'checkout.authPrompt': 'Bitte melden Sie sich an oder registrieren Sie sich, um den Bestellvorgang fortzusetzen.',
  'checkout.authSignup': 'Registrieren',
  'checkout.backToConfirm': 'Zuruck zur Bestellbestatigung',
  'checkout.backToShop': 'Zuruck zum Shop',
  'checkout.bankName': 'Name der Bank',
  'checkout.btcStep1': "Schließen Sie Ihre Bestellung ab, um die Zahlungsseite zu öffnen.",
  'checkout.btcStep2': "Senden Sie den genauen BTC-Betrag über das angegebene Netzwerk an die angezeigte Adresse.",
  'checkout.btcStep3': "Bezahlen Sie, bevor die Zahlungsdaten ablaufen.",
  'checkout.btcOrderNote': "Verwenden Sie diese Zahlungsdaten nur für diese Bestellung. Eine telefonische Bestätigung ist nicht erforderlich.",
  'checkout.btcHelp': "Bitcoin kaufen",
  "checkout.cryptoTitle": "Mit Kryptowährung bezahlen",
  "checkout.cryptoStep1": "Klicken Sie auf Weiter.",
  "checkout.cryptoStep2": "Wählen Sie auf der nächsten Seite Ihre Kryptowährung und das Netzwerk.",
  "checkout.cryptoStep3": "Folgen Sie den Zahlungsanweisungen, um Ihre Zahlung abzuschließen.",
  "checkout.cryptoCoinsLabel": "Verfügbare Kryptowährungen",
  "checkout.cryptoCoins": "Ethereum · Litecoin · Bitcoin Cash · Dogecoin · Monero · Tron · XRP · Cardano · TON · BNB",
  "checkout.cryptoNetworks": "Wählen Sie Ethereum (ERC-20), Tron (TRC-20) oder BNB Smart Chain (BEP-20).",
  "checkout.cryptoBitcoinTitle": "Möchten Sie mit Bitcoin (BTC) bezahlen?",
  "checkout.cryptoBitcoinNote": "Wählen Sie beim Checkout die separate Zahlungsart Bitcoin.",
  'checkout.btcTitle': "Mit Bitcoin bezahlen",
  'checkout.cartEmpty': 'Ihr Warenkorb ist leer.',
  'checkout.ccNumber': 'Kreditkartennummer (keine Leerzeichen oder Bindestriche)',
  'checkout.ccType': 'Kreditkartentyp',
  'checkout.checkNumber': 'Schecknummer',
  'checkout.cvv': 'CVV2',
  'checkout.error': 'Es ist ein Fehler aufgetreten',
  'checkout.expDate': 'Verfallsdatum',
  'checkout.loading': 'Checkout wird geladen...',
  'checkout.noPayments': 'Fur den Checkout sind leider keine Zahlungen moglich. Bitte wenden Sie sich an die Vertriebs- oder Supportabteilung.',
  'checkout.paymentFailed': 'Zahlungsmethode konnte nicht festgelegt werden',
  'checkout.processing': 'Verarbeitung...',
  'checkout.routingHint': 'Bankleitzahl (ABA-Code) - Normalerweise 9 Ziffern auf Ihrem Scheck.',
  'checkout.routingNumber': 'Routing-Nummer (ABA-Code)',
  'checkout.selectPayment': 'Wahlen Sie eine Zahlungsmethode aus',
  'contact.email': 'E-Mail',
  'contact.hours': 'Arbeitszeit',
  'contact.previewHours': 'Mo-Fr 9:00-18:00',
  'contact.support247': 'Kundenservice 24/7',
  'contact.live_chat': 'Live-Chat',
  'contact.open_ticket': 'Offnen Sie ein Ticket',
  'contact.phone': 'Telefon',
  'contact.start_chat': 'Chat starten',
  'contact.tickets_desc': 'Haben Sie eine Frage? Eroffnen Sie ein Support-Ticket und wir werden uns bei Ihnen melden.',
  'contact.title': 'Kontaktieren Sie uns',
  'contact.unavailable': 'Kontaktinformationen sind nicht verfugbar.',
  'deleteAccount.attention': 'Aufmerksamkeit!',
  'deleteAccount.failed': 'Die Anfrage ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'deleteAccount.password': 'Passwort',
  'deleteAccount.passwordRequired': 'Passwort ist erforderlich.',
  'deleteAccount.reason': 'Grund',
  'deleteAccount.reasonHint': 'Bitte teilen Sie uns den Grund fur Ihren Weggang mit. Ihr Feedback hilft uns, uns zu verbessern.',
  'deleteAccount.reasonRequired': 'Begrundung ist erforderlich.',
  'deleteAccount.rule1': 'In Ihrem Verlauf sollten sich keine Ruckbuchungen befinden.',
  'deleteAccount.rule2': 'Nach Ihrer letzten erfolgreichen Bestellung mussen mindestens 21 Tage vergehen.',
  'deleteAccount.rules': 'Regeln zur Kontoloschung:',
  'deleteAccount.safetyInfo': 'Ihre Privatsphare ist uns wichtig. Sie konnen Ihr Konto und den zugehorigen Verlauf jederzeit dauerhaft loschen.',
  'deleteAccount.submit': 'Einreichen',
  'deleteAccount.success': 'Konto erfolgreich geloscht.',
  'deleteAccount.thanks': 'Vielen Dank, dass Sie sich fur unseren Service entschieden haben.',
  'deleteAccount.warning': 'Wenn fur eine Bestellung spater eine Ruckbuchung eingeht, wird Ihr Konto moglicherweise wiederhergestellt, um diesen Fall zu bearbeiten. Bei Fragen wenden Sie sich rund um die Uhr an den Support.',
  'profile.address': 'Adresse',
  'profile.addressRequired': 'Adresse ist erforderlich',
  'profile.billingAddress': 'Rechnungsadresse',
  'profile.changePassword': 'Kennwort andern',
  'profile.city': 'Stadt',
  'profile.cityRequired': 'Stadt ist erforderlich',
  'profile.confirmPassword': 'Passwort bestatigen',
  'profile.country': 'Land',
  'profile.countryRequired': 'Land ist erforderlich',
  'profile.email': 'E-Mail',
  'profile.emailInvalid': 'Ungultiges E-Mail-Format',
  'profile.emailRequired': 'E-Mail ist erforderlich',
  'profile.firstName': 'Vorname',
  'profile.firstNameRequired': 'Der Vorname ist erforderlich',
  'profile.lastName': 'Nachname',
  'profile.lastNameRequired': 'Nachname ist erforderlich',
  'profile.loadFailed': 'Profildaten konnten nicht geladen werden',
  'profile.loading': 'Profil wird geladen...',
  'profile.mr': 'Herr.',
  'profile.mrs': 'Frau',
  'profile.ms': 'Frau',
  'profile.newPassword': 'Neues Passwort',
  'profile.passwordHint': 'Lassen Sie das Feld leer, wenn Sie Ihr Passwort nicht andern mochten.',
  'profile.passwordMinLength': 'Das Passwort muss mindestens 5 Zeichen lang sein',
  'profile.passwordMismatch': 'Passworter stimmen nicht uberein',
  'profile.personalInfo': 'Personliche Informationen',
  'profile.phone': 'Telefon',
  'profile.phoneRequired': 'Telefon ist erforderlich',
  'profile.sameAsBilling': 'Entspricht der Rechnungsadresse',
  'profile.saving': 'Speichern...',
  'profile.selectCountry': 'Wahlen Sie Land aus',
  'profile.selectState': 'Wahlen Sie Staat aus',
  'profile.shippingAddress': 'Lieferadresse',
  'profile.state': 'Bundesland',
  'profile.stateProvince': 'Staat/Provinz',
  'profile.title': 'Titel',
  'profile.updateFailed': 'Update fehlgeschlagen',
  'profile.updateSuccess': 'Profil erfolgreich aktualisiert',
  'profile.zipcode': 'PLZ',
  'profile.zipcodeRequired': 'Postleitzahl ist erforderlich',
  'select.noResults': 'Keine Ergebnisse gefunden',
  'select.placeholder': 'Wahlen...',
  'select.search': 'Suchen...',
  'tickets.activationFailed': 'Aktivierungs-E-Mail konnte nicht gesendet werden',
  'tickets.activationSuccess': 'Aktivierungs-E-Mail erfolgreich gesendet',
  'tickets.authInstructions': 'Wenn Sie es aktivieren mochten, klicken Sie bitte auf die Schaltflache unten. Wir senden Ihnen dann die Anweisungen per E-Mail zu.',
  'tickets.authNotActivated': 'Das Ticketsystem ist fur Ihr Konto noch nicht freigeschaltet.',
  'tickets.backToTickets': 'Zuruck zu Tickets',
  'tickets.createSuccess': 'Ticket erfolgreich erstellt',
  'tickets.date': 'Datum',
  'tickets.dateLabel': 'Datum:',
  'tickets.detailLoading': 'Ticket wird geladen...',
  'tickets.empty': 'Zur Zeit keine Tickets gefunden. Verwenden Sie \"Neues Ticket eroffnen\", um eine Frage zu stellen',
  'tickets.fileLimit': 'Wahlen Sie bis zu 3 Dateien aus.',
  'tickets.lastReply': 'Letzte Antwort',
  'tickets.loading': 'Tickets werden geladen...',
  'tickets.loadingMore': 'Mehr laden...',
  'tickets.message': 'Nachricht',
  'tickets.newSubject': 'Thema',
  'tickets.newTicketTitle': 'Neues Ticket offnen',
  'tickets.noMessages': 'Keine Nachrichten gefunden.',
  'tickets.messagesHeading': 'Nachrichten',
  'tickets.messageFromSupport': 'Support',
  'tickets.messageFromYou': 'Sie',
  'tickets.replyHeading': 'Antworten',
  'tickets.attachFiles': 'Dateien anhängen',
  'tickets.filesCount': '{count} Datei(en)',
  'tickets.notActivated': 'Das Ticketsystem ist fur Ihr Konto nicht aktiviert.',
  'tickets.openNew': 'Neues Ticket offnen',
  'tickets.refresh': 'Aktualisieren',
  'tickets.resolve': 'Ticket losen',
  'tickets.resolveConfirm': 'Sind Sie sicher, dass Sie dieses Ticket losen mochten?',
  'tickets.sendActivation': 'Aktivierungs-E-Mail senden',
  'tickets.sendReply': 'Antwort senden',
  'tickets.status': 'Status',
  'tickets.statusAwaitingAgent': 'Wartender Agent',
  'tickets.statusAwaitingUser': 'Warten auf Benutzer',
  'tickets.statusLabel': 'Status:',
  'tickets.statusPending': 'Ausstehend',
  'tickets.statusResolved': 'Gelost',
  'tickets.subject': 'Thema',
  'tickets.submitTicket': 'Ticket einreichen',
  'tickets.title': 'Support-Tickets',
  'tickets.uploadFiles': 'Dateien hochladen (PDF, JPG, PNG, TXT)',
  'close': 'Schließen',
  'loading': 'Laden...',
  'yes': 'Ja',
  'no': 'Nein',
  'tickets.unavailable': 'Support-Tickets sind vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut oder kontaktieren Sie den Support per E-Mail bei Dringlichkeit.',
  'api.genericError': 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
  'api.networkError': 'Der Dienst ist vorübergehend nicht verfügbar. Überprüfen Sie Ihre Verbindung.',
  'api.error.10503': 'Dienst nicht verfügbar',
  'api.error.40001': 'Die Kundenauthentifizierung ist fehlgeschlagen',
  'api.error.40004': 'Die Kundendatenvalidierung ist fehlgeschlagen',
  'api.error.40008': 'Dieser Login existiert bereits',
  'api.error.40009': 'Diese E-Mail existiert bereits',
  'api.error.40021': 'Das Kundenkonto existiert bereits',
  'api.error.40022': 'Kunde nicht gefunden',
  'api.error.400014': 'Der Gutschein ist ungültig',
  'api.error.50001': 'Betrugsprüfung fehlgeschlagen',
  'api.error.50002': 'Das Konto hat offene Bestellungen und kann nicht gelöscht werden.',
  'api.error.60001': 'Dieses Produkt ist derzeit nicht verfügbar.',
  'geo.soft_notice': 'This product has delivery region limits. Final availability is confirmed after sign-in using your shipping address.',
  'api.error.60101': 'Sie können höchstens {limit} verschiedene Produkte pro Bestellung hinzufügen.',
  'api.error.60102': 'Die maximale Menge für dieses Produkt ist {limit}.',
  'api.error.60103': 'Die maximale Packungsanzahl für dieses Produkt ist {limit}.',
  'unsubscribe.processing': 'Wird verarbeitet…',
  'unsubscribe.success': 'Sie wurden von Marketing-E-Mails von {shop_name} abgemeldet.',
  'unsubscribe.shop': 'Shop',
  'unsubscribe.invalidLink': 'Ungültiger oder abgelaufener Link.',
  'unsubscribe.error': 'Ein Fehler ist aufgetreten.',

  'title.orderReturn': 'Zahlungsstatus',
  'orderReturn.successTitle': 'Vielen Dank!',
  'orderReturn.successLead': 'Ihre Zahlung wurde erfolgreich empfangen.',
  'orderReturn.successHint': 'Eine Bestätigungs-E-Mail wurde versendet. Versandinformationen folgen.',
  'orderReturn.cancelTitle': 'Zahlung abgebrochen',
  'orderReturn.cancelLead': 'Für diese Bestellung wurde keine Zahlung vorgenommen.',
  'orderReturn.cancelHint': 'Nach dem Checkout ist der Warenkorb leer. Nutzen Sie die Bestelldetails oder „Erneut versuchen“ unten.',
  'orderReturn.failureTitle': 'Zahlung fehlgeschlagen',
  'orderReturn.failureLead': 'Wir konnten die Zahlung für diese Bestellung nicht abschließen.',
  'orderReturn.failureHint': 'Der Warenkorb wurde bei der Bestellung geleert. Erneut versuchen, Bestelldetails anzeigen oder Support kontaktieren.',
  'orderReturn.btnDetails': 'Bestelldetails anzeigen',
  'orderReturn.btnSignIn': 'Anmelden, um Details anzuzeigen',
  'orderReturn.btnContinueShopping': 'Weiter einkaufen',
  'orderReturn.btnContactSupport': 'Support kontaktieren',
  'orderReturn.btnTryAgain': 'Erneut versuchen',
  'confirm.loadFailed': 'Bestelldetails konnten nicht geladen werden',
  'confirm.shippingAddress': 'Lieferadresse',
  'confirm.edit': 'Bearbeiten',
  'confirm.paymentMethod': 'Zahlungsmethode',
  'confirm.notSelected': 'Nicht ausgewählt',
  'confirm.shippingNote': '*US2US-Versand dauert typischerweise 3 Werktage nach Versand (bis zu 5 Werktage).',
  'confirm.overseasShippingNote': '*Auslandsversand dauert typischerweise 14-28 Werktage für EU- und indische Produkte.',
  'confirm.manufacturerNote': '*Wir haben mehrere Hersteller dieses Produkts. Wenn der von Ihnen bestellte Hersteller derzeit nicht auf Lager ist, kontaktieren wir Sie und bieten eine Alternative an.',
  'confirm.agreePolicy': 'Hiermit erkläre ich, dass ich der Rückerstattungsrichtlinie und der Chargeback-Richtlinie zustimme',
  'confirm.back': 'Zurück',
  'confirm.placing': 'Bestellung wird aufgegeben...',
  'confirm.previewModeNotice': 'Vorschaumodus - echte Bestellungen sind deaktiviert.',
  'confirm.success': 'Bestellung erfolgreich aufgegeben!',
  'confirm.invalidResponse': 'Ungültige Bestellantwort',
  'confirm.failed': 'Bestellung konnte nicht aufgegeben werden',
  'qnr.loading': 'Fragebogen wird geladen...',
  'qnr.loadFailed': 'Fragebogen konnte nicht geladen werden',
  'qnr.retry': 'Erneut versuchen',
  'qnr.intro': 'Bitte füllen Sie dieses Formular aus, um das Rezept für das bestellte Medikament anzufordern. Es sind dieselben Informationen, die Sie in einer Klinik oder bei einem Arzt angeben würden.',
  'qnr.general': 'Allgemeine Informationen',
  'qnr.dob': 'Geburtsdatum des Patienten',
  'qnr.day': 'Tag',
  'qnr.month': 'Monat',
  'qnr.year': 'Jahr',
  'qnr.dobRequired': 'Geburtsdatum ist erforderlich',
  'qnr.gender': 'Geschlecht',
  'qnr.selectPlaceholder': 'Auswählen...',
  'qnr.genderRequired': 'Geschlecht ist erforderlich',
  'qnr.height': 'Größe des Patienten',
  'qnr.heightRequired': 'Größe ist erforderlich',
  'qnr.weight': 'Gewicht des Patienten',
  'qnr.weightRequired': 'Gewicht ist erforderlich',
  'qnr.medicalHistory': 'Medizinische Vorgeschichte',
  'qnr.disorderQuestion': 'Welche Erkrankung oder Beschwerde ist der Grund für die Anforderung dieses Medikaments?',
  'qnr.conditionRequired': 'Medizinischer Zustand ist erforderlich',
  'qnr.otherDisease': 'Haben Sie eine andere Krankheit, Störung oder ein anderes medizinisches Problem?',
  'qnr.yesNo': 'Bitte antworten Sie mit Ja oder Nein',
  'qnr.specifyOther': 'Falls ja, bitte angeben',
  'qnr.specifyRequired': 'Bitte geben Sie andere medizinische Probleme an',
  'qnr.confirmations': 'Bestätigungen',
  'qnr.declaration': 'Ich erkläre, dass die von mir gemachten Angaben vollständig und ohne Vorbehalt sind...',
  'qnr.declarationRequired': 'Erklärung ist erforderlich',
  'qnr.responsibility': 'Erklärung zur Kundenverantwortung',
  'qnr.responsibilityRequired': 'Erklärung zur Verantwortung ist erforderlich',
  'qnr.consent': 'Ich erkläre, dass ich der Einverständniserklärung zustimme',
  'qnr.consentRequired': 'Einverständniserklärung ist erforderlich',
  'qnr.yes': 'Ja',
  'qnr.no': 'Nein',
  'qnr.back': 'Zurück',
  'qnr.saving': 'Wird gespeichert...',
  'qnr.continue': 'Weiter',
  'qnr.saved': 'Medizinischer Fragebogen gespeichert',
  'qnr.saveFailed': 'Fragebogen konnte nicht gespeichert werden',
  'validate.ccEmpty': 'Kartennummer darf nicht leer sein',
  'validate.ccInvalid': 'Kartennummer ist ungültig',
  'validate.ccAmex': 'Amex-Kartennummer muss gültig sein',
  'validate.ccMaster': 'MasterCard-Nummer muss gültig sein',
  'validate.ccVisa': 'Visa-Kartennummer muss gültig sein',
  'validate.ccTypeEmpty': 'Kartentyp darf nicht leer sein',
  'validate.cvvDigits': 'CVV2 muss 3-4 Ziffern haben',
  'validate.cvvEmpty': 'CVV2 darf nicht leer sein',
  'validate.bankEmpty': 'Bankname darf nicht leer sein',
  'validate.bankLength': 'Bankname muss 1 bis 32 Zeichen lang sein',
  'validate.chequeEmpty': 'Schecknummer darf nicht leer sein',
  'validate.chequeDigits': 'Schecknummer darf nur Ziffern enthalten',
  'validate.chequeLength': 'Schecknummer muss 1 bis 16 Zeichen lang sein',
  'validate.routingEmpty': 'Routing-Nummer darf nicht leer sein',
  'validate.routingDigits': 'Routing-Nummer darf nur Ziffern enthalten',
  'validate.routingLength': 'Routing-Nummer muss 1 bis 16 Zeichen lang sein',
  'validate.accountEmpty': 'Kontonummer darf nicht leer sein',
  'validate.accountDigits': 'Kontonummer darf nur Ziffern enthalten',
  'validate.accountLength': 'Kontonummer muss 1 bis 16 Zeichen lang sein',
  'paymentMethod.credit_card_amex': 'Kreditkarte (Amex)',
  'paymentMethod.credit_card': 'Kreditkarte',
  'paymentMethod.echeque': 'E-Scheck',
  'paymentMethod.bitcoin': 'Bitcoin',
  'paymentCard.amex': 'Amex',
  'paymentCard.mc': 'MasterCard',
  'paymentCard.visa': 'Visa',
  'orderSuccess.placedSuccess': 'Ihre Bestellung wurde erfolgreich aufgegeben.',
  'orderSuccess.thanks': 'Vielen Dank! Ihre Bestellung wurde aufgegeben.',
  'orderSuccess.orderId': 'Bestell-ID:',
  'orderSuccess.description': 'Sie erhalten eine Bestellbestätigung per E-Mail. Wir bearbeiten Ihre Bestellung so schnell wie möglich.',
  'orderSuccess.orderDetails': 'Bestelldetails',
  'orderSuccess.viewOrders': 'Meine Bestellungen ansehen',
  'orderSuccess.close': 'Zurück zum Shop',
  'pagination.label': 'Seitennavigation',
  'pagination.first': 'Erste',
  'pagination.previous': 'Zurück',
  'pagination.next': 'Weiter',
  'pagination.last': 'Letzte',

  // ── OrdersView (list/filter) ──
  'orders.loading': 'Bestellungen werden geladen...',
  'orders.loadFailed': 'Bestellungen konnten nicht geladen werden',
  'orders.empty': 'Noch keine Bestellungen.',
  'orders.filter': 'Filter:',
  'orders.allTime': 'Gesamter Zeitraum',
  'orders.thisMonth': 'Dieser Monat',
  'orders.thisWeek': 'Diese Woche',
  'orders.today': 'Heute',

  // ── BonusAccountPage ──
  'referralProgram.headline': 'Freund einladen: {friend} % für ihn, {reward} % für Sie.',
  'referralProgram.intro': 'Teilen Sie Ihren persönlichen Link. Nachdem Ihr Freund seine erste Bestellung erhalten hat, erscheint hier ein eigener {reward}-%-Gutschein.',
  'referralProgram.how': 'Ihr Freund erhält {friend} % auf die erste Bestellung. Sie erhalten nach dem Versand einen {reward}-%-Gutschein, der {months} Monate gültig ist.',
  'referralProgram.rulesTitle': 'Gutscheinregeln',
  'referralProgram.ruleSeparate': 'Für jeden geworbenen Neukunden erhalten Sie einen eigenen Gutschein.',
  'referralProgram.ruleOnePerOrder': 'Pro Bestellung kann nur ein Gutschein verwendet werden.',
  'referralProgram.ruleNoLimit': 'Der {reward}-%-Rabatt hat keinen Höchstbetrag.',
  'referralProgram.couponsTitle': 'Ihre Empfehlungs-Gutscheine',
  'referralProgram.noCoupons': 'Sie haben noch keine Empfehlungs-Gutscheine.',
  'referralProgram.apply': 'Im Warenkorb anwenden',
  'referralProgram.applying': 'Wird angewendet…',
  'referralProgram.expires': 'Gültig bis',
  'referralProgram.status.active': 'Aktiv',
  'referralProgram.status.redeemed': 'Verwendet',
  'referralProgram.status.expired': 'Abgelaufen',
  'referralProgram.status.revoked': 'Nicht verfügbar',
  'referralShare.button': 'Teilen',
  'referralShare.signIn': 'Melden Sie sich an oder erstellen Sie ein Konto, um Ihren persönlichen Empfehlungslink zu teilen.',
  'referralShare.signInButton': 'Zum Teilen anmelden',
  'referralShare.copied': 'Empfehlungslink kopiert.',
  'referralShare.failed': 'Der Empfehlungslink konnte nicht geteilt oder kopiert werden.',
  'referralShare.ready': 'Ihr Link ist bereit. Tippen Sie zum Teilen auf Teilen.',
  'referralCoupon.loginRequired': 'Bitte melden Sie sich an, um Ihren Rabattgutschein anzuwenden.',
  'referralCoupon.applied': 'Ihr {reward}-%-Gutschein wurde angewendet.',
  'referralCoupon.appliedGeneric': 'Ihr Rabattgutschein wurde angewendet.',
  'referralCoupon.applyFailed': 'Der Gutschein konnte nicht angewendet werden. Bitte versuchen Sie es in Ihrem Konto erneut.',
  'bonus.headline': 'Verdienen Sie lebenslange Boni mit unserem Empfehlungsprogramm',
  'bonus.intro': 'Laden Sie Freunde ein und verdienen Sie Boni für deren Einkäufe. Sie können Ihr Bonusguthaben für bis zu 50 % Ihrer nächsten Bestellung verwenden.',
  'bonus.howTitle': 'Wie funktioniert es?',
  'bonus.howDesc': 'Teilen Sie Ihren persönlichen Empfehlungslink oder -code. Wenn ein neuer Kunde damit bestellt, erhalten Sie 15 % des versendeten Bestellwerts als Bonusguthaben.',
  'bonus.subsequent': 'Für jede weitere versendete Bestellung erhalten Sie zusätzlich 5 %.',
  'bonus.friendBenefits': 'Welche Vorteile hat Ihr Freund?',
  'bonus.friendDiscount': 'Ihr Freund erhält 20 % Rabatt auf die erste Bestellung mit Ihrem Link oder Code.',
  'bonus.whyGreat': 'Warum das für Sie großartig ist:',
  'bonus.benefit1': 'Boni können bis zu 50 % des Bestellwerts abdecken.',
  'bonus.benefit2': 'Sie werden benachrichtigt, sobald Ihr Bonusguthaben gutgeschrieben wird.',
  'bonus.benefit3': 'Verdienen Sie auch mit Unter-Empfehlungen: 10 % der Boni, die Ihre direkte Empfehlung erhält.',
  'bonus.startSharing': 'Teilen Sie Ihren Empfehlungslink und beginnen Sie noch heute zu verdienen.',
  'bonus.refLinkLabel': 'Ihr Empfehlungslink (zum Kopieren klicken)',
  'bonus.copy': 'In Zwischenablage kopieren',
  'bonus.copied': 'Kopiert',
  'bonus.copyFailed': 'Kopieren fehlgeschlagen',
  'bonus.refCodeIntro': 'Alternativ können Sie Ihren eindeutigen Code teilen, den Ihre Empfehlungen als Gutscheincode verwenden können.',
  'bonus.transactions': 'Bonus-Kontotransaktionen',
  'bonus.referralTree': 'Empfehlungsbaum',

  // ── BonusTransactionsPage ──
  'bonusTx.loading': 'Wird geladen...',
  'bonusTx.back': 'Zurück',
  'bonusTx.balance': 'Bonus-Konto:',
  'bonusTx.date': 'Datum',
  'bonusTx.addedBonus': 'Gutgeschriebener Bonus',
  'bonusTx.usedBonus': 'Verwendeter Bonus',
  'bonusTx.type': 'Typ',
  'bonusTx.empty': 'In Ihrem Bonus-Konto gibt es noch keine Transaktionen.',
  'bonusTx.typeM': 'Bonus aus einem Empfehlungskauf',
  'bonusTx.typeC': 'Bonus aus einem Unter-Empfehlungskauf',
  'bonusTx.typeO': 'Bonus zur Bezahlung Ihrer Bestellung',
  'bonusTx.typeOOrder': 'Bonus zur Bezahlung Ihrer Bestellung Nr. {orderId}',
  'bonusTx.typeP': 'Geschenk',
  'bonusTx.typeW': 'Auszahlung',

  // ── ReferralPage ──
  'referral.back': 'Zurück',
  'referral.loading': 'Wird geladen...',
  'referral.empty': 'Keine Empfehlungsdaten verfügbar.',
  'referral.description': 'Dieser Bereich zeigt den Empfehlungsbaum ab Ihnen. Er enthält auch Statistiken zu Boni eines bestimmten Empfehlungsgebers und seines Zweigs. Unser mehrstufiges System ermöglicht es Ihnen, 10 % der Empfehlungsboni der Empfehlungen Ihrer direkten Empfehlungen zu verdienen.',
  'referral.referral': 'Empfehlung',
  'referral.bonuses': 'Empfehlungsboni',
  'referral.subBonuses': 'Unter-Empfehlungsboni',
  'referral.level': 'Stufe:',
  'referral.bonusesNote': 'Empfehlungsboni — Boni aus Käufen Ihrer direkten Empfehlungen.',
  'referral.subBonusesNote': 'Unter-Empfehlungsboni — Boni aus Empfehlungen Ihrer Empfehlungen.',
};
